import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { reduxForm, initialize, formValueSelector } from 'redux-form';
import { addContract, editContract, setStep } from 'redux/modules/newContract';
import { GrayButton, ModalTopBar, SecondaryButton, Stepper, NewContractForm, PageHeader, Spinner } from 'components';
import { LeftNavLayout } from 'containers';
import { browserHistory } from 'react-router';
import moment from 'moment';
var selector = formValueSelector('newContract');
var NewContract = (_dec = reduxForm({
  form: 'newContract'
}), _dec2 = connect(function (state) {
  return {
    contract: state.contract,
    currentStep: state.newContract.step,
    newFormData: state.newContract.data,
    formValues: state.form.newContract ? state.form.newContract.values : {},
    isLoadingFromSf: state.newContract.isLoadingFromSf,
    isSaving: state.newContract.saving
  };
}, {
  initialize: initialize,
  addContract: addContract,
  editContract: editContract,
  setStep: setStep
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(NewContract, _Component);

  var _super = _createSuper(NewContract);

  function NewContract(props) {
    var _this;

    _classCallCheck(this, NewContract);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (!_this.props.isEdit) {
        _this.props.setStep(1);
      }

      var c = null;

      if (_this.props.isEdit && _this.props.contract) {
        c = _this.props.contract;
      }

      var products = c ? c.ContractProducts : [];
      var hasProduct = !!products.length;

      _this.props.initialize('newContract', {
        uuid: c && c.uuid ? c.uuid : null,
        sfid: c && c.crmUrl ? c.crmUrl : '',
        firstName: c && c.firstName ? c.firstName : '',
        lastName: c && c.lastName ? c.lastName : '',
        contractStartsAt: c && c.contractStartsAt ? moment(c.contractStartsAt).toDate() : new Date(),
        email: c && c.email ? c.email : '',
        phone: c && c.phone ? c.phone : '',
        address_id: c && c.Address ? c.Address.id : null,
        address1: c && c.Address ? c.Address.address1 : '',
        address2: c && c.Address ? c.Address.address2 : '',
        locality: c && c.Address ? c.Address.locality : '',
        region: c && c.Address ? c.Address.region : '',
        postcode: c && c.Address ? c.Address.postcode : '',
        country: c && c.Address ? c.Address.country : null,
        Product: c && hasProduct ? {
          id: c.Products[0].id
        } : {
          id: 6
        },
        paymentMethod: c && c.paymentMethodId ? {
          id: c.paymentMethodId
        } : {
          id: 6
        },
        quantity: c && hasProduct ? c.Products[0].ContractProduct.quantity : 1,
        contractMonths: c && hasProduct ? c.Products[0].ContractProduct.contractMonths : 12,
        setupFee: c && hasProduct ? c.Products[0].ContractProduct.setupFee : 99,
        monthlyFee: c && hasProduct ? c.Products[0].ContractProduct.monthlyFee : 199,
        monthlyAdsBudget: c && hasProduct ? c.Products[0].ContractProduct.monthlyAdsBudget : 25,
        monthlyCustomFee: c && hasProduct ? c.Products[0].ContractProduct.monthlyCustomFee : 0,
        paymentDetailEntryType: _this.props.isEdit && c.paymentDetailEntryType ? c.paymentDetailEntryType : 2
      });
    });

    _defineProperty(_assertThisInitialized(_this), "requiredFields", ['firstName', 'lastName', 'locality', 'region', 'postcode', 'email', 'businessName', 'phone']);

    _defineProperty(_assertThisInitialized(_this), "validateRequired", function (val) {
      return val !== '';
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (data) {
      // validate
      var errorMessage = '';

      _this.requiredFields.forEach(function (f) {
        var valid = _this.validateRequired(data[f]);

        if (!valid) {
          errorMessage += "".concat(f, " is required.\n");
        }
      });

      if (errorMessage !== '') {
        alert(errorMessage);
      } else {
        _this.setState({
          sendingContract: true
        });

        if (_this.props.isEdit) {
          _this.props.editContract(data).then(function (savedcontract) {
            browserHistory.push("/global/agreements/".concat(savedcontract.data.uuid, "/teamview/"));
          })["catch"](function (err) {
            console.error(err);
          });
        } else {
          _this.props.addContract(data).then(function (savedcontract) {
            browserHistory.push("/global/agreements/".concat(savedcontract.uuid, "/teamview/"));
          })["catch"](function (err) {
            console.error(err);
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "nextStep", function (maxSteps) {
      if (_this.props.currentStep === maxSteps) {
        _this.props.setStep(_this.props.currentStep + 1);

        _this.setState({
          disableBack: true,
          disableSubmit: true
        });
      } else {
        _this.props.setStep(_this.props.currentStep + 1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "steps", [{
      label: 'Edit Customer Details'
    }, {
      label: 'Select Products'
    }, {
      label: 'Payment'
    }]);

    _defineProperty(_assertThisInitialized(_this), "handleLeave", function () {
      var result = window.confirm('Are you sure you want to leave? You will lose all changes.');

      if (result) {
        browserHistory.push('/global/agreements');
      }
    });

    _this.state = {
      disableBack: false,
      disableSubmit: false,
      sendingContract: false
    };
    return _this;
  }

  _createClass(NewContract, [{
    key: "updateFormWithResults",
    value: function updateFormWithResults(newFormData) {
      this.props.initialize('newContract', _objectSpread(_objectSpread({}, this.props.formValues), newFormData));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          paddingBottom: 36
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "".concat(this.props.isEdit ? 'Edit' : 'New', " Customer Agreement")
      }), /*#__PURE__*/React.createElement(ModalTopBar, {
        handleGoBack: this.handleLeave,
        showCloseBtn: false,
        style: {
          position: 'static',
          marginBottom: 24
        },
        backLabel: "View All Agreements"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid",
        style: {
          padding: 36,
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "".concat(this.props.isEdit ? 'Edit' : 'New', " Customer"),
        secondary: "Agreement"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          display: 'flex',
          justifyContent: 'space-around'
        }
      }, /*#__PURE__*/React.createElement(Stepper, {
        steps: this.steps,
        currentStep: this.props.currentStep,
        clickableSteps: false,
        onChange: this.handleStepperChange
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 24
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.props.isSaving ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(NewContractForm, {
        isEdit: this.props.isEdit,
        onSubmit: this.handleSubmit,
        totalSteps: this.steps.length
      }))), !this.state.sendingContract ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 20
        }
      }, this.props.currentStep > 1 ? /*#__PURE__*/React.createElement(GrayButton, {
        onClick: function onClick() {
          return _this2.props.setStep(_this2.props.currentStep - 1);
        },
        label: "Previous"
      }) : /*#__PURE__*/React.createElement(GrayButton, {
        onClick: this.handleLeave,
        label: "Cancel"
      }), /*#__PURE__*/React.createElement(SecondaryButton, {
        primary: false,
        disabled: this.state.disableSubmit,
        onClick: function onClick() {
          if (_this2.steps.length > _this2.props.currentStep) {
            _this2.nextStep(_this2.steps.length);
          } else {
            _this2.handleSubmit(_this2.props.formValues);
          }
        },
        label: this.steps.length === this.props.currentStep ? 'Submit' : 'Next',
        style: {
          marginLeft: 24
        }
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%',
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))));
    }
  }]);

  return NewContract;
}(Component), _defineProperty(_class2, "propTypes", {
  initialize: PropTypes.func.isRequired,
  addContract: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  contract: PropTypes.object,
  editContract: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  newFormData: PropTypes.object,
  formValues: PropTypes.object,
  isSaving: PropTypes.bool
}), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object.isRequired
}), _temp)) || _class) || _class);
export { NewContract as default };